import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import style from './index.module.scss'
import cross from '../../../static/images/cross.svg'
import { withRouter } from 'react-router-dom'

const ModalWindowWrapper = ({
  title,
  miniTitle,
  content,
  onClose,
  history,
}) => {
  const [container] = React.useState(document.createElement('div'))

  container.classList.add('portal')

  useEffect(() => {
    document.body.appendChild(container)
    return () => {
      document.body.removeChild(container)
    }
  }, [container])

  // Close modal by press button ESC
  useEffect(() => {
    const closeModal = (event) => {
      if (event.keyCode === 27) {
        onClose()
      }
    }
    document.addEventListener('keydown', closeModal)

    return () => document.removeEventListener('keydown', closeModal)
  }, [onClose])

  const onCloseByClick = (event) => {
    if (
      window.location.pathname === '/password/reset' &&
      event.target === document.getElementById('cross')
    ) {
      history.push({
        pathname: '/',
        state: { isMapPage: false },
      })
    }
  }

  return ReactDOM.createPortal(
    <div
      className={style.backdrop}
      data-backdrop="overlay"
      onClick={onCloseByClick}
    >
      <div className={style.modal}>
        <div className={style.header}>
          <h2 className={`${style.title} ${miniTitle ? style.miniTitle : ''}`}>
            {title}
          </h2>
          <img src={cross} alt="cross" onClick={()=>{
            onClose(true)
          }}
            id={'cross'} />
        </div>
        {content}
      </div>
    </div>,
    container,
  )
}

export default withRouter(ModalWindowWrapper)
